import { toWebpImageUrl } from './imageUrl';

/**
 * Build a cart line item consistent with ShopPage / ProductPage.
 */
export function buildCartItem(product, { variant } = {}) {
  if (!product?.id) {
    return null;
  }

  let name = product.name || 'Product';
  if (variant) {
    name = `${name} (${variant})`;
  }

  return {
    id: String(product.id),
    name,
    price: Number(product.price) || 0,
    image: toWebpImageUrl(product.image_url || product.image),
    category: product.category,
  };
}

export function isProductInStock(product) {
  if (!product) return false;
  if (product.in_stock === false) return false;
  if (product.inStock === false) return false;
  return true;
}
